import {Showroom} from '_app/types/api'

export const parseShowroomAddress = (showroom: Showroom) => {
  const stringElems = (showroom.address || '')
    .split(',')
    .map(item => item.trim())

  const streetString = stringElems[stringElems.length - 1]
  const streetElements = (
    streetString.match(new RegExp(/([\d\s]*[\D]*)([\S\-\/]*)(.*)/))?.slice(1, 4) || ['', '', '']
  ).map(elem => elem.trim())
  const [street, streetNo, streetDetails] = streetElements

  return {
    street: [street, streetNo, streetDetails],
    postcode: stringElems[1],
    city: stringElems[0],
  }
}
